/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import _get from 'lodash/get'
import { SetLanguage, ILanguageOption } from 'redux-app/types/localization'
import AccessWrapper from 'apps/AccessWrapper'
import Select, { SelectItem } from 'elements/Select'
import UserControls from './apps/UserControls'
import * as styles from './HeaderActions.scss'

interface IProps {
  activeLang: string,
  setLanguage: SetLanguage,
  isUserControlsVisible: boolean,
  languageOptions: ILanguageOption[],
  isTextsLoading: boolean,
}

const HeaderActions: React.FC<IProps> = ({
  activeLang,
  setLanguage,
  isUserControlsVisible,
  languageOptions,
  isTextsLoading,
}) => (
  <ul className={styles.root}>
    {__IS_LOCALIZATION_ACTIVE__ && (
    <AccessWrapper>
      <li className={styles.lang}>
        <Select
          id='language'
          styleType='headerLang'
          dropDownAlignment='right'
          title={_get(languageOptions.find(item => item.value === activeLang), 'label')}
          disabled={isTextsLoading}
        >
          {languageOptions.map(({ label, value }) => (
            <SelectItem
              key={value}
              onClick={() => { setLanguage(value) }}
              active={activeLang === value}
            >
              {label}
            </SelectItem>
          ))}
        </Select>
      </li>
    </AccessWrapper>
    )}
    {isUserControlsVisible && [
      <li key='separator' className={styles.separator} />,
      <li key='user' className={styles.user}>
        <UserControls />
      </li>,
    ]}
  </ul >
)

export default HeaderActions
